<manage-wrapper
  *ngIf="!!asset"
  [canEditMain]="!readOnly"
  [entityTitle]="asset.name"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [readOnly]="readOnly"
  [labels]="asset.labels || []"
  [labelMap]="labelMap"
  [labelList]="labels"
  [deleteTitle]="'Delete this asset'"
  [canDuplicate]="false"
  [labelUpdateFunction]="readOnly ? null : labelUpdateFunction.bind(this)"
  [type]="'asset'"
  [whiteTitle]="true"
  [titlePlaceholder]="'asset'"
  [backgroundColor]="'#FF8A5C'"
  [dialogTitle]="'Manage asset'"
  [topToggleText]="asset.ready ? 'Ready' : 'Not ready'"
  [topToggled]="!!asset.ready"
  [clipLabel]="clipLabel"
  (onToggle)="toggleReady()"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (saveTitle)="updateAssetName($event)"
  (onDelete)="deleteAsset()"
  (onClip)="clip()"
>

  <div class="afterTitle">

    <menu-hover-button [readOnly]="readOnly" class="flag smooth" iconSelector="flagoff" hoverText="Flag" [tooltipLeft]="true"
      [warn]="asset.flagged" (click)="readOnly ? null : toggleFlagged()">
    </menu-hover-button>

    <menu-hover-button [readOnly]="readOnly" class="flag smooth" [iconSelector]="'BUDGET48'" [hoverText]="'Show in Budget Link'" [tooltipLeft]="true" [warn]="asset.showInBudget" (click)="readOnly ? null : toggleShowInBudget()">
    </menu-hover-button>

    <menu-hover-button [readOnly]="readOnly" id="iconButton" [iconSelector]="asset.icon"
      [hoverText]="'Choose asset type'" [text]="!asset.icon ? 'Type' : null" 
      [lightText]="!asset.icon" (click)="readOnly ? null : setIcon()"></menu-hover-button>

    <entity-types 
      [readOnly]="readOnly"
      [entityType]="'asset'"
      [entity]="asset"
    ></entity-types>
    
    <menu-hover-button [readOnly]="readOnly" class="calendar smooth" iconSelector="calendar" hoverText="Manage due date"
      [text]="!asset?.dueDate ? 'Due date' : asset.dueDate | date:'EEE d MMM'" [lightText]="!asset?.dueDate" (click)="readOnly ? null : picker.open()">
      <mat-form-field class="date_field">
        <input hidden matInput id="date" name="date" #pickerInput [matDatepicker]="picker" [ngModel]="asset.dueDate" (ngModelChange)="setDueDate($event)">
        <mat-datepicker class="picker" #picker [startAt]="asset?.dueDate || today"></mat-datepicker>
      </mat-form-field>
    </menu-hover-button>
    
    <menu-hover-button [readOnly]="readOnly" *ngIf="!!asset.dueDate && !readOnly" class="delete-date" iconSelector="delete18"
      [noBackground]="true" hoverText="Remove due date" (click)="removeDueDate($event)"></menu-hover-button>

    <menu-hover-button [readOnly]="readOnly" id="responsibilityButton" *ngIf="{w: workersByEmail[asset?.responsibility] } as w" [iconSelector]="!w.w ? 'ADD_TO_WORKFORCE' : null"
      hoverText="Manage responsibility" [text]="!w.w ? 'Responsibility' : w.w.firstName + ' ' + w.w.lastName" 
      [lightText]="!w.w" [worker]="w.w" (click)="readOnly ? null : setResponsibleWorker()"></menu-hover-button>
    
    <menu-hover-button [readOnly]="readOnly" id="entityButton" class="entity-button" [hoverText]="'Associate asset with...'"
      [iconSelector]="'associate'" [lightText]="!entities[asset.associatedId]" (click)="readOnly ? null : associateAsset()"
      [text]="entities[asset.associatedId]?.name || 'Associated with'"></menu-hover-button>

    <menu-hover-button [readOnly]="readOnly" *ngIf="workersByUId[asset?.createdBy] as creator" class="creator" [noBackground]="true" 
      [hoverText]="'Created by ' + creator.firstName + ' ' + creator.lastName" [worker]="creator"></menu-hover-button>
      
    
    <menu-hover-button [readOnly]="readOnly" *ngIf="asset?.createdType && entities[asset.createdBy] as entity" class="creator" [noBackground]="true" 
      [hoverText]="'Created by ' + asset.createdType + ': ' + entity.name" [entity]="entity"></menu-hover-button>
  </div>

  <ng-container *ngIf="!selectedTab || selectedTab?.id === tabs.details">
    <title-toggle-wrapper
      *ngIf="{ submitter: entities[asset.submitterId], off: !asset.status || asset.status === 'Off' } as vars"
      style="display: block; margin-bottom: 20px;"
      [title]="'Receive asset information'"
      [hideBottom]="vars.off"
      [toggleOn]="!vars.off"
      (toggle)="submitToggle($event)"
    >
      <div style="margin-bottom: 20px">
        Share webform to receive asset information.
      </div>

      <ng-container *ngIf="vars.submitter ? vars.submitter.name + ' (' + asset.submitterType + ')' : 'anyone' as submitter">

        <div class="receive-from">
          Receive asset information from:         
          <fake-dropdown style="margin-left: 10px" id="submitterDiv" [title]="submitter" (click)="getSubmitter()"></fake-dropdown>
        </div>

        <div style="margin-bottom: 10px">
          YOUR SHAREABLE WEBFORM:
        </div>
      </ng-container>


      <share-code 
        [shareType]="'fullAsset'"
        [shareCode]="event.eventId + '/' + asset.id" 
        [hideTitle]="true"
        [disabled]="!['Active', 'Submitted'].includes(asset.status)"
        [hideJson]="true"
        [emailGenerator]="emailGenerator.bind(this)"
        [selectedStatus]="asset.status"
        (changeStatus)="changeStatus($event)">
      </share-code>

      <div class="hint" style="margin-top: 10px;">
        Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.
      </div>

    </title-toggle-wrapper>

    <div class="quantity-holder">
      <title-icon [title]="'Asset Quantity'"></title-icon>
      <joi-input 
        [(model)]="asset.quantity" 
        [fixedWidth]="true"
        [placeholder]="readOnly ? '' : 'Qty...'"
        [outlined]="!readOnly"
        [displayValue]="asset.quantity ? (asset.quantity | prettyNumbers:2:1:false:true) : null"
        [allowableCharacters]="'0123456789.'"
        [disabled]="readOnly"
        (joiChange)="updateQuantity()"
      ></joi-input>
    </div>
    
    <title-icon [title]="'Asset Information'" [titleIcon]="'description18'"></title-icon>
    <joi-input style="margin-bottom: 40px" [disabled]="readOnly" [italicPlaceholder]="true" [(model)]="asset.description" [type]="'textarea'" [returnable]="true" [placeholder]="'Click to add asset information...'" (joiChange)="saveAsset()"></joi-input>
    
    <title-icon [title]="'Link to asset URL'" [titleIcon]="'LINK18'"></title-icon>
    <url-handler [readOnly]="readOnly" [name]="asset.name || ''" [url]="asset.link" (changeUrl)="asset.link = $event; saveAsset()" ></url-handler>

    


  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.attached">
    
    <div class="attached" *ngIf="attachedToCountByAssetId[asset.id] === 0 ">
      <div class="hint">This asset has not been added to anything yet.</div>
    </div>
  
    <div class="attached" [ngClass]="{ clickable: !readOnly }" *ngIf="attachedToCountByAssetId[asset.id] > 0">
      <div class="mb" *ngIf="eventInformationItemsByAssetIds[asset.id]?.length && eventInformationItemsByAssetIds[asset.id] as EI">
        <h5>Event information</h5>
        <grey-wrapper *ngFor="let i of EI" (click)="manageInformableItem(i)" >{{ i.assetItemTitle }}</grey-wrapper>
      </div>
      <div class="mb" *ngIf="performerInformationItemsByAssetIds[asset.id]?.length && performerInformationItemsByAssetIds[asset.id] as PI">
        <h5>Information for Performer Brief</h5>
        <grey-wrapper *ngFor="let i of PI" (click)="manageInformableItem(i, 'performers', 'information for performer brief')" >{{ i.assetItemTitle }}</grey-wrapper>
      </div>
      <div class="mb" *ngIf="exhibitorInformationItemsByAssetIds[asset.id]?.length && exhibitorInformationItemsByAssetIds[asset.id] as PI">
        <h5>Information for Exhibitor Brief</h5>
        <grey-wrapper *ngFor="let i of PI" (click)="manageInformableItem(i, 'exhibitors', 'information for exhibitor brief')" >{{ i.assetItemTitle }}</grey-wrapper>
      </div>
      <div class="mb" *ngIf="resourceInformationItemsByAssetIds[asset.id]?.length && resourceInformationItemsByAssetIds[asset.id] as PI">
        <h5>Information for Resource Brief</h5>
        <grey-wrapper *ngFor="let i of PI" (click)="manageInformableItem(i, 'resources', 'information for resource brief')" >{{ i.assetItemTitle }}</grey-wrapper>
      </div>

      <div class="mb" *ngIf="programsByAssetIds[asset.id]?.length && programsByAssetIds[asset.id] as programs">
        <h5>Rooms / locations</h5>
        <grey-wrapper [ngClass]="{ placeholder: !p.title }" *ngFor="let p of programs" (click)="manageProgram(p.id)" >{{ p.title || 'Untitled Room / Location'}}</grey-wrapper>
      </div>
      <div class="mb" *ngIf="setupsByAssetIds[asset.id]?.length && setupsByAssetIds[asset.id] as setups">
        <h5>Setups</h5>
        <grey-wrapper [ngClass]="{ placeholder: !s.name }" *ngFor="let s of setups" (click)="manageProgram(s.programId, 'setup')" >{{ s.name || 'Untitled setup'}}</grey-wrapper>
      </div>
      <div class="mb" *ngIf="sessionsByAssetIds[asset.id]?.length && sessionsByAssetIds[asset.id] as sessions">
        <h5>Sessions</h5>
        <grey-wrapper [ngClass]="{ placeholder: !s.assetSessionTitle }" *ngFor="let s of sessions" (click)="manageSession(s.id)" >{{ s.assetSessionTitle || 'Untitled Session' }}</grey-wrapper>
      </div>
      <div class="mb" *ngIf="runOfShowByAssetIds[asset.id]?.length && runOfShowByAssetIds[asset.id] as runs">
        <h5>Run of shows</h5>
        <grey-wrapper *ngFor="let r of runs" (click)="manageSession(r.sessionId, 'cues')" >{{ r.name }} ({{ r.countByAssetIds[asset.id] }})</grey-wrapper>
      </div>
      <div class="mb" *ngIf="exhibitorStandsByAssetIds[asset.id]?.length && exhibitorStandsByAssetIds[asset.id] as stands">
        <h5>Exhibitor Stands</h5>
        <grey-wrapper [ngClass]="{ placeholder: !s.name }" *ngFor="let s of stands" (click)="manageExhibitorStand(s)" >{{ s.name || 'Untitled Exhibitor Stand' }}</grey-wrapper> 
      </div>
      <div class="mb"  *ngIf="activityDataByAssetIds[asset.id]?.length && activityDataByAssetIds[asset.id] as activityDatas">
        <h5>Activities</h5>
        <grey-wrapper [ngClass]="{ placeholder: !a.assetTitle }" *ngFor="let a of activityDatas" (click)="manageActivity(a)" >{{ a.assetTitle || 'Untitled Activity' }}</grey-wrapper>
      </div>
  
    </div>  
  </ng-container>

  <entity-tasks *ngIf="selectedTab?.id === tabs.tasks" [entity]="asset" [changeDetectorRef]="changeDetectorRef"></entity-tasks>
  
</manage-wrapper>